import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Box, ButtonBase, Checkbox, Dialog, FormControlLabel, IconButton, Typography } from '@material-ui/core';
import { CloseIcon } from '../../../../../components/Icon';
import { baseCssOccupieddischarge } from '../baseCss';
import BedStatusIcon from '../../BedStatusIcon';
import { i18n } from '../../../../../language';
import { bedP as P } from '../../../bsApp';

export default function Updatetounavailable({ closePop, allData, open, confirmHandle }) {
  const remarks = [
    { text: i18n.t('BEDSTATUS_MAINTENANCE'), key: P.maintenance },
    { text: i18n.t('BEDSTATUS_RESUSCITATION'), key: P.resuscitation },
    { text: i18n.t('BEDSTATUS_LIFE_SAVING_EQUIPMENT'), key: P.lifeSavingEquipment },
    { text: 'Frozen', key: P.frozenYn },
  ];

  const baseClasses = baseCssOccupieddischarge();

  const [InputValues, setInputValues] = useState({
    [P.maintenance]: allData?.[P.maintenance],
    [P.resuscitation]: allData?.[P.resuscitation],
    [P.lifeSavingEquipment]: allData?.[P.lifeSavingEquipment],
    [P.airbornePrecaution]: allData?.[P.airbornePrecaution],
    [P.dropletPrecaution]: allData?.[P.dropletPrecaution],
    [P.contactPrecaution]: allData?.[P.contactPrecaution],
  });
  useEffect(() => {
    setInputValues({
      [P.maintenance]: allData?.[P.maintenance],
      [P.resuscitation]: allData?.[P.resuscitation],
      [P.lifeSavingEquipment]: allData?.[P.lifeSavingEquipment],
      [P.airbornePrecaution]: allData?.[P.airbornePrecaution],
      [P.dropletPrecaution]: allData?.[P.dropletPrecaution],
      [P.contactPrecaution]: allData?.[P.contactPrecaution],
    });
  }, [allData]);

  const changeHandle = (type, key) => {
    return (event) => {
      if (type === 'check') {
        setInputValues({ ...InputValues, [key]: Number(event.target.checked) });
      }
    };
  };

  const confirmClick = () => {
    if (typeof confirmHandle === 'function') {
      confirmHandle(InputValues);
    }
  };

  return (
    <Dialog open={open} maxWidth={false}>
      <div className={baseClasses.root}>
        <div className={baseClasses.header} style={{ padding: '2.063rem 1.56rem 1.688rem' }}>
          <Typography className={baseClasses.headerTitle}>{i18n.t('BEDSTATUS_UPDATE_TO_UNAVAILABLE')}</Typography>
          <IconButton id="bed_updatetounavailable_close" className={baseClasses.closeIcon} onClick={closePop}>
            <CloseIcon />
          </IconButton>
        </div>
        <Box overflow="auto" display="flex" flexDirection="column" p="0 1.56rem">
          <Typography className={baseClasses.areYouSureYouWou} style={{ marginBottom: '1.75rem' }}>
            {i18n.t('BEDSTATUS_ARE_YOU_SURE_TO_UPDATE_BED__TO_UNAVAILABLE', { value: allData?.[P.bedNo] ?? '' })}
          </Typography>
          <div className={baseClasses.statusBox}>
            <div className={baseClasses.status}>
              <BedStatusIcon allData={allData} bedNo={allData?.[P.bedNo] ?? ''} />
            </div>
            <Box display="flex" flexDirection="column">
              <Typography className={baseClasses.labelText}>{i18n.t('BEDSTATUS_PATIENT_ID')}</Typography>
              <Typography className={baseClasses.statusText}>N/A</Typography>
            </Box>
          </div>
          <Typography className={baseClasses.others} style={{ margin: '1.85rem 0 0.5rem 0' }}>
            {i18n.t('BEDSTATUS_REMARKS')}
          </Typography>
          {_.map(remarks, (item) => {
            return (
              <span key={item.key}>
                <FormControlLabel
                  id={`bed_updatetounavailable_${item.key}`}
                  control={<Checkbox />}
                  label={item.text}
                  className={baseClasses.checkBox}
                  style={{ marginTop: '0.2rem' }}
                  onChange={changeHandle('check', item.key)}
                  checked={Boolean(InputValues?.[item.key])}
                />
              </span>
            );
          })}
        </Box>

        <div className={baseClasses.bottom} style={{ boxShadow: '0 -1px 0 0 #e4e7eb' }}>
          <ButtonBase
            id="bed_updatetounavailable_cancel"
            className={baseClasses.cancelBtn}
            style={{ marginRight: '1.25rem' }}
            onClick={closePop}
          >
            {i18n.t('BEDSTATUS_CANCEL')}
          </ButtonBase>
          <ButtonBase id="bed_updatetounavailable_confirm" className={baseClasses.configBtn} onClick={confirmClick}>
            {i18n.t('BEDSTATUS_CONFIRM')}
          </ButtonBase>
        </div>
      </div>
    </Dialog>
  );
}
